import { api } from "./api";

/**
 * Regulamento ativo mais recente de um tipo. Os tipos em uso hoje são
 * `campanha`, `cards` e `mercado_estrelas`.
 */
export async function getRegulamento(type = "campanha") {
  const payload = [
    { $match: { active: true, type } },
    { $sort: { created: -1 } },
    { $limit: 1 },
  ];

  const { data } = await api.post(`database/regulamento__c/aggregate`, payload);
  return Array.isArray(data) ? data : [];
}
